module.exports = __webpack_public_path__ + "img/185.7767634b.jpg";